const Work = ({ closeApp }) => {
    return (
        <div>

            <div style={{ textAlign: 'left' }}>

                <h2 style={{ marginLeft: '40px', marginBottom: '0px', fontSize: '1.4em' }}>Work</h2>

                <div style={{ marginLeft: '40px', marginRight: '30px', fontSize: '0.7em' }}>
                    <br />
                    For the past 7 years I work as a Senior Tools Engineer at Netflix. I work on the Observability Platform team.
                    We provide and maintain tools such as Atlas, Radar, and Raven which provide
                    graphs, dashboarding, logs, and real time data for troubleshooting and monitoring.

                </div>
            </div>
            
            <div className="app-open-close-button">
                <button onClick={closeApp}>Close</button>
            </div>
            <br />
            
        </div>
    );
};
export default Work;